import {importModalVideo} from "./kp-util";

const videoButtons = document.querySelectorAll('.js-modal-btn')

if (videoButtons.length > 0) {
    importModalVideo().then((ModalVideo) => {

        // load youtube iframe API
        let tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        const onPlayerReady = (e) => {
            const player = e.target
            //console.log(player.playerInfo)
        }

        const onPlayerStateChange = (e) => {
            const player = e.target
            //console.log(player.playerInfo)
        }

        // function gets called when youtube iframe API is loaded
        window.onYouTubeIframeAPIReady = () => {
            new ModalVideo(videoButtons, {
                youtube: {
                    enablejsapi: 1,
                }
            });

            videoButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const videoIframe = document.querySelector('.modal-video iframe')
                    const player = new YT.Player(videoIframe, {
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        }
                    })
                })
            })
        }
    })
}

